"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Button_1 = require("./Button");
var DefaultTheme_1 = require("../../themes/DefaultTheme");
var Header = styled_components_1["default"].h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: 'Oswald';\n    font-size: ", ";\n    color: hsla(0,0%,100%,.7);\n    display: block;\n    padding-bottom: 10px;\n    border-bottom: 2px solid hsla(0,0%,100%,.4);\n"], ["\n    font-family: 'Oswald';\n    font-size: ", ";\n    color: hsla(0,0%,100%,.7);\n    display: block;\n    padding-bottom: 10px;\n    border-bottom: 2px solid hsla(0,0%,100%,.4);\n"])), DefaultTheme_1.DefaultTheme.Spacing[4]);
var Column = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 0 28px;\n    width: 100%;\n"], ["\n    padding: 0 28px;\n    width: 100%;\n"])));
exports.ButtonColumn = function (props) {
    return (React.createElement(Column, null,
        React.createElement(Header, null, props.blok.Header),
        React.createElement(Button_1.Button, { target: "_BLANK", href: props.blok.ButtonLink.url }, props.blok.ButtonText)));
};
var templateObject_1, templateObject_2;
